import React from "react"

const IconWithText = ({ imgSrc, text, className = "", imgAlt = ""
}) => {
  return (
    <div className={`c-icon-with-text ${className}`}>
      <img 
        className="c-icon-with-text__image"
        src={imgSrc} 
        alt={imgAlt} 
      />
      <span className="c-icon-with-text__text">
        {text}
      </span>
    </div>
  )
}

export default IconWithText;
